import ApiClient from '@/services/apiClient';

export default class LPR {
    id;
    name;
    ip;
    minimal_confidence;
    brand;
    image_retention_days;
    image_retention_condition;

    static constructFromObject(data, obj) {
        obj = obj || new LPR();
        if (data) {
            obj.id = ApiClient.convertToType(data['id'], 'Integer');
            obj.name = ApiClient.convertToType(data['name'], 'String');
            obj.ip = ApiClient.convertToType(data['ip'], 'String');
            obj.minimal_confidence = ApiClient.convertToType(data['minimal_confidence'], 'Integer');
            obj.brand = ApiClient.convertToType(data['brand'], 'String');
            obj.image_retention_days = ApiClient.convertToType(data['image_retention_days'], 'Integer');
            obj.image_retention_condition = ApiClient.convertToType(data['image_retention_condition'], 'String');
        }
        return obj;
    }

    toJSON() {
        return {
            id: this.id,
            name: this.name,
            ip: this.ip,
            minimal_confidence: this.minimal_confidence,
            brand: this.brand,
            image_retention_days: this.image_retention_days,
            image_retention_condition: this.image_retention_condition,
        }
    }
}
